export const getMaxValueOfArray = (array) => {
  return Math.max.apply(Math, array)
}

export const differenceTwoArrays = (array_one, array_two) => {
  // Если массивы пустые, тогда и сраванить не нужно
  if (array_one.length == 0 && array_two.length == 0) {
    return true
  } else {
    // JSON.stringify медленнее, чем Array.join, но для этого метода нет проблем с вложенными объектами
    return JSON.stringify(array_one) === JSON.stringify(array_two)
  }
}

export class ClassTime {
  toNext(v, prefix = ' хв.') {
    return v != null ? `${(v).toFixed(1)}${prefix}` : '-'
  }

  timestampToLocaleTime(v) {
    return v != null ? new Date(v * 1000).toLocaleTimeString() : '-'
  }

  toMin(v, prefix = ' хв.') {
    if(v != null) {
      let ms = v * 60000
      let m = Math.floor(ms / 60000)
      let s = ((ms % 60000) / 1000).toFixed(0)
      if (s === '60') { m++; s = '0' }
      const addZero = (i) => i < 10 ? `0${i}` : i

      return `${addZero(m)}:${addZero(s)}${prefix}`
    } else { return '-' }
  }
}

export class ClassComputedOffsetByMap {
  tooltipByFontSize(font_size) {
    let left = 18
    let top = 16

    switch (font_size) {
      case 10:
        top = 11
        break;
      case 12:
        top = 16
        break;
      case 14:
        top = 18
        break;
      default:
        break;
    }

    return [left, top]
  }

  popupByFontSize(font_size) {
    let list_length = 8
    let item_height = 21
    let left = 145
    let top = 210

    switch (font_size) {
      case 10:
        item_height = 18
        left = 128
        break;
      case 12:
        item_height = 21
        left = 145
        break;
      case 14:
        item_height = 24
        left = 162
        break;
      default:
        break;
    }

    top = (list_length * item_height) + 42

    return [left, top]
  }
}